import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ParametrizacaoLimites } from 'src/app/@shared/models/parametrizacao-limites.model';
import { ParametrizacaoLimitesService } from 'src/app/services/parametrizacao-limites/parametrizacao-limites.service';

@Component({
  selector: 'app-parametrizacao-limites',
  templateUrl: './parametrizacao-limites.component.html',
  styleUrls: ['./parametrizacao-limites.component.scss']
})
export class ParametrizacaoLimitesComponent implements OnInit {
  isLoading: boolean = true;
  listaItems: ParametrizacaoLimites[];
  displayedColumns: string[] = ['tipoManifesto', 'valorLimite', 'bloqueiaOperacao']; 
  tipoManifesto: any;

  constructor(
    private parametrizacaoLimitesService: ParametrizacaoLimitesService,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.listarParametrizacaoLimiteValor();
  }

  listarParametrizacaoLimiteValor() {
    this.isLoading = true;
    
    this.parametrizacaoLimitesService.listarParametrizacaoLimiteValor().subscribe(
      (response: ParametrizacaoLimites[]) => {
        this.listaItems = response;
        this.isLoading = false;
      }, 
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      })
  }

  editarParametrizacaoLimiteValor(elemento: any, campo: string, valor: any) {
    const obj: ParametrizacaoLimites = {
      ...elemento,
      [campo]: valor
    }
    delete obj.tipoManifesto;
    delete obj.manifestoLimiteId;
    
    if (campo === 'valorLimite') {
      obj[campo] = +valor.replaceAll('.', '')
        .replace(',', '.')
        .replace('R$ ', '');
    }

    this.parametrizacaoLimitesService.editarParametrizacaoLimiteValor(elemento.tipoManifesto, obj)  
      .subscribe(response => {
        if (response.sucesso) {
          this.openSnackBar(`Campo editado com sucesso!`, 'OK', 5000, 'success-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar('Erro ao editar Limite, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      })
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
